var map = {
	"./castel-cafe.jpg": 62,
	"./city-skyline.jpg": 63,
	"./colosseum.jpg": 64,
	"./concrete-building.jpg": 65,
	"./dawn-nature.jpg": 66,
	"./high-rise-building.jpg": 67,
	"./hot-air-balloons.jpg": 68,
	"./la-interstate.jpg": 69,
	"./lake-bled.jpg": 70,
	"./lake-near-mountains.jpg": 71,
	"./monument.jpg": 72,
	"./nipa-huts.jpg": 73,
	"./palm-trees.jpg": 74,
	"./temple.jpg": 75,
	"./the-blue-mosque.jpg": 76,
	"./travel.jpg": 77,
	"./white-and-blue-concrete.jpg": 78,
	"./white-city.jpg": 79
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61;